<template>
  <div v-if="user" class="min-h-screen bg-gray-100">
    <SidebarMenu 
      :user="user" 
      :isMenuOpen="isMenuOpen" 
      @toggle-menu="toggleMenu" 
      @close-menu="closeMenu" 
      @logout="logout"
    />

    <!-- Contenido Principal - ajustado para tener margen izquierdo en escritorio -->
    <div class="md:ml-64">
      <main class="p-4">
        <div class="p-4">
          <h1 class="text-xl font-bold mb-4">Inicio</h1>

          <div v-if="warningMessage" v-html="warningMessage" class="mb-6 bg-yellow-50 border border-yellow-200 text-yellow-700 px-4 py-3 rounded"></div>
          
          <!-- Dashboard de Indicadores -->
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
            <!-- Indicador 1: Colegiaturas pendientes -->
            <div 
              @click="$router.push('/calendario-colegiaturas')"
              class="bg-white rounded-lg shadow p-4 transition-all duration-300 hover:shadow-lg cursor-pointer"
            >
              <div class="flex flex-col items-center">
                <div class="text-red-500 text-3xl mb-2">
                  {{ cargandoColegiaturas ? '...' : `$${formatCurrency(totalColegiaturasPendientes)}` }}
                </div>
                <div class="text-gray-600 text-center">Saldo pendiente</div>
                <div v-if="cargandoColegiaturas" class="mt-2">
                  <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-red-500"></div>
                </div>
              </div>
            </div>
            
            <!-- NUEVO INDICADOR: Próximo pago -->
            <div 
              @click="$router.push('/calendario-colegiaturas')"
              class="bg-white rounded-lg shadow p-4 transition-all duration-300 hover:shadow-lg cursor-pointer"
            >
              <div class="flex flex-col items-center">
                <div class="text-blue-500 text-3xl mb-2">
                  {{ cargandoColegiaturas ? '...' : `$${formatCurrency(proximoPagoBalance)}` }}
                </div>
                <div class="text-gray-600 text-center">
                Próximo pago <span style="white-space: nowrap;">{{ cargandoColegiaturas ? '...' : (proximoPagoFecha ? formatDate(proximoPagoFecha) : '') }}</span>
                </div>
                <div v-if="cargandoColegiaturas" class="mt-2">
                  <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500"></div>
                </div>
              </div>
            </div>
            
            <!-- Indicador 2: Adeudos de convenio(s) -->
            <div 
              @click="$router.push('/calendario-convenio')"
              class="bg-white rounded-lg shadow p-4 transition-all duration-300 hover:shadow-lg cursor-pointer"
            >
              <div class="flex flex-col items-center">
                <div class="text-red-500 text-3xl mb-2">
                  {{ cargandoConvenios ? '...' : `$${formatCurrency(totalAdeudosConvenio)}` }}
                </div>
                <div class="text-gray-600 text-center">Saldo pendiente de convenio</div>
                <div v-if="cargandoConvenios" class="mt-2">
                  <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-red-500"></div>
                </div>
              </div>
            </div>
            
            <!-- Indicador 3: Mis prospectos -->
            <div 
              @click="$router.push('/historial-prospectos')"
              class="bg-white rounded-lg shadow p-4 transition-all duration-300 hover:shadow-lg cursor-pointer"
            >
              <div class="flex flex-col items-center">
                <div class="text-blue-500 text-3xl mb-2">
                  {{ cargandoProspectos ? '...' : totalProspectos }}
                </div>
                <div class="text-gray-600 text-center">Mis prospectos</div>
                <div v-if="cargandoProspectos" class="mt-2">
                  <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500"></div>
                </div>
              </div>
            </div>
            
            <!-- Indicador 4: Prospectos por vencer -->
            <div 
              @click="$router.push('/historial-prospectos')"
              class="bg-white rounded-lg shadow p-4 transition-all duration-300 hover:shadow-lg cursor-pointer"
            >
              <div class="flex flex-col items-center">
                <div class="text-red-500 text-3xl mb-2">
                  {{ cargandoProspectos ? '...' : prospectosPorVencer }}
                </div>
                <div class="text-gray-600 text-center">Prospectos por vencer</div>
                <div v-if="cargandoProspectos" class="mt-2">
                  <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-red-500"></div>
                </div>
              </div>
            </div>
          </div>
          
          <h2 class="hidden text-xl font-bold">Avisos y noticias</h2>
          <!-- Contenedor de notificaciones con responsive design -->
          <div class="hidden mt-6">
            
            <!-- Flexbox container: row en desktop, column en móvil -->
            <div class="flex flex-col md:flex-row gap-4">
              
              <!-- Placeholder 1 -->
              <div class="bg-gray-100 p-4 rounded-lg border border-gray-200 flex-1">
                <div class="w-12 h-12 rounded-full bg-gray-300 mb-3"></div>
                <div class="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
                <div class="h-3 bg-gray-200 rounded w-full mb-1"></div>
                <div class="h-3 bg-gray-200 rounded w-5/6"></div>
              </div>
              
              <!-- Placeholder 2 -->
              <div class="bg-gray-100 p-4 rounded-lg border border-gray-200 flex-1">
                <div class="w-12 h-12 rounded-full bg-gray-300 mb-3"></div>
                <div class="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
                <div class="h-3 bg-gray-200 rounded w-full mb-1"></div>
                <div class="h-3 bg-gray-200 rounded w-5/6"></div>
              </div>
              
              <!-- Placeholder 3 -->
              <div class="bg-gray-100 p-4 rounded-lg border border-gray-200 flex-1">
                <div class="w-12 h-12 rounded-full bg-gray-300 mb-3"></div>
                <div class="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
                <div class="h-3 bg-gray-200 rounded w-full mb-1"></div>
                <div class="h-3 bg-gray-200 rounded w-5/6"></div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import SidebarMenu from '@/components/SidebarMenu.vue';
import { 
  getCalendarioColegiatura, 
  getCalendarioConvenio, 
  getProspects,  
  getStudentPhoto,
  getPendingNotices,
  getStudentData
  //acknowledgeNotice
} from "@/services/api";

export default {
  components: {
    SidebarMenu
  },
  data() {
    return {
      user: null,
      isMenuOpen: false,
      totalColegiaturasPendientes: 0,
      totalAdeudosConvenio: 0,
      totalProspectos: 0,
      prospectosPorVencer: 0,
      cargandoColegiaturas: true,
      cargandoConvenios: true,
      cargandoProspectos: true,
      proximoPagoFecha: null,
      proximoPagoBalance: 0,
      pendingNotices: [],
      currentNoticeIndex: 0,
      warningMessage: null,
      studentId: null
    };
  },
  async created() {
    await this.getUserFromBackend();

    // Verificar y actualizar foto si es necesario
    await this.checkAndUpdatePhotoIfNeeded();
    
    // Cargar mensaje de advertencia
    await this.loadWarningMessage();
    
    // Cargar los datos de los indicadores en paralelo
    this.cargarColegiaturasPendientes();
    this.cargarAdeudosConvenio();
    this.cargarProspectos();
    
    // Cargar y mostrar avisos pendientes
    await this.loadAndShowNotices();
  },
  methods: {
    async getUserFromBackend() {
      try {
        const response = await axios.get('/me');
        this.user = response.data.user;
        
        if (this.user.email && this.user.email.match(/^a(\d+)@/)) {
          this.studentId = this.user.email.match(/^a(\d+)@/)[1];
        } else {
          this.error = "No se pudo extraer el ID de estudiante del email.";
          this.loading = false;
        }
      } catch (error) {
        console.error("Error obteniendo usuario", error);
        this.$router.push('/login');
      }
    },
    
    async loadWarningMessage() {
      if (!this.studentId) return;
      
      try {
        const response = await getStudentData(this.studentId);
        if (response.data && response.data.length > 0) {
          const warning = response.data[0].Warning;
          if (warning && warning.trim() !== '') {
            this.warningMessage = warning;
          }
        }
      } catch (error) {
        console.error('Error cargando mensaje de advertencia:', error);
      }
    },
    
    async loadAndShowNotices() {
      try {
        const response = await getPendingNotices();
        
        if (response.data.success && response.data.notices.length > 0) {
          this.pendingNotices = response.data.notices;
          this.currentNoticeIndex = 0;
          
          // Mostrar el primer aviso
          this.showNotice(this.pendingNotices[0]);
        }
      } catch (error) {
        console.error('Error cargando avisos:', error);
      }
    },
    
    showNotice(notice) {
      // Mapeo de tipos a iconos de SweetAlert
      const iconMap = {
        'info': 'info',
        'warning': 'warning',
        'success': 'success',
        'error': 'error'
      };
      
      // Convertir saltos de línea en el mensaje a HTML
      const formattedMessage = notice.message.replace(/\n/g, '<br>');
      
      Swal.fire({
        title: notice.title,
        html: formattedMessage,
        icon: iconMap[notice.type] || 'info',
        showCancelButton: false,
        confirmButtonText: 'Cerrar',
        cancelButtonText: 'Cerrar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#6c757d',
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          popup: 'notice-popup',
          title: 'notice-title',
          htmlContainer: 'notice-content'
        }
      }).then(async () => {
        //Por el momento el mensaje debe aparecer siempre
        //const action = result.isConfirmed ? 'understood' : 'closed';
        
        try {
          //Por el momento el mensaje debe aparecer siempre
          //await acknowledgeNotice(notice.id, action);
          
          // Si hay más avisos pendientes, mostrar el siguiente
          this.currentNoticeIndex++;
          if (this.currentNoticeIndex < this.pendingNotices.length) {
            // Pequeña pausa antes de mostrar el siguiente aviso
            setTimeout(() => {
              this.showNotice(this.pendingNotices[this.currentNoticeIndex]);
            }, 300);
          }
        } catch (error) {
          console.error('Error al reconocer aviso:', error);
          Swal.fire({
            title: 'Error',
            text: 'No se pudo registrar la acción. Por favor, intenta nuevamente.',
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      });
    },
    
    async cargarColegiaturasPendientes() {
      try {
        const response = await getCalendarioColegiatura({ idstudent: this.studentId });
        this.data = response.data;
        this.loading = false;

        const fechaActual = new Date();

        // Calcular colegiaturas vencidas
        this.totalColegiaturasPendientes = response.data.reduce((total, item) => {
          const fechaLimite = new Date(item.week_payment_date);
          // Solo contar si la fecha límite ya pasó
          if (fechaLimite < fechaActual) {
            return total + (item.balance || 0);
          }
          return total;
        }, 0);

        // Encontrar el próximo pago
        let proximoPago = null;
        
        // Ordenar pagos por fecha
        const pagosFuturos = response.data
          .filter(item => {
            const fechaLimite = new Date(item.week_payment_date);
            return fechaLimite >= fechaActual && item.balance > 0;
          })
          .sort((a, b) => {
            return new Date(a.week_payment_date) - new Date(b.week_payment_date);
          });
        
        // Tomar el primer pago futuro (el más cercano)
        if (pagosFuturos.length > 0) {
          proximoPago = pagosFuturos[0];
          this.proximoPagoFecha = proximoPago.week_payment_date;
          this.proximoPagoBalance = proximoPago.balance || 0;
        } else {
          // Si no hay pagos futuros, mostrar valores por defecto o mensaje
          this.proximoPagoFecha = null;
          this.proximoPagoBalance = 0;
        }
      } catch (error) {
        console.error('Error obteniendo colegiaturas pendientes', error);
      } finally {
        this.cargandoColegiaturas = false;
      }
    },
    async cargarAdeudosConvenio() {
      try {
        const response = await getCalendarioConvenio({ idstudent: this.studentId });
        this.data = response.data;
        this.loading = false;

        const fechaActual = new Date();
        
        this.totalAdeudosConvenio = response.data.reduce((total, item) => {
          const fechaLimite = new Date(item.payment_date_limit);
          // Solo contar si la fecha límite ya pasó
          if (fechaLimite < fechaActual && item.active === 1) {
            return total + (item.balance || 0);
          }
          return total;
        }, 0);
      } catch (error) {
        console.error('Error obteniendo adeudos de convenio', error);
      } finally {
        this.cargandoConvenios = false;
      }
    },
    async cargarProspectos() {
      try {
        const params = {
          _dc: '',
          page: 1,
          start: 0,
          limit: 50,
          filter: JSON.stringify([
            {"property":"pSource","value":"GET_Prospects"},
            {"property":"pName","value":""},
            {"property":"pStatusId","value":""},
            {"property":"pPromotorName","value":""},
            {"property":"pStartDate","value":"1900-12-12"},
            {"property":"pEndDate","value":"2090-12-12"},
            {"property":"pUserName","value": this.studentId || ""}
          ])
        };
        
        const response = await getProspects(params);
        // Calcular total de prospectos
        this.totalProspectos = response.data.prospects.length;
        
        // Calcular prospectos por vencer (5 días o menos)
        this.prospectosPorVencer = response.data.prospects.filter(prospecto => {
          const diasExpiracion = parseInt(prospecto.ExpirationDate?.split(' ')[0]) || 0;
          return diasExpiracion <= 5;
        }).length;
      } catch (error) {
        console.error('Error obteniendo prospectos', error);
      } finally {
        this.cargandoProspectos = false;
      }
    },
    formatDate(fecha) {
      if (!fecha) return '';
      const date = new Date(fecha);
      return date.toISOString().split('T')[0]; // Formato YYYY-MM-DD
    },
    formatCurrency(value) {
      return value.toLocaleString('es-MX');
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    async logout() {
      try {
        // Obtener nuevo token CSRF
        await axios.get('/sanctum/csrf-cookie');
        
        // Esperar un momento para asegurar que la cookie se haya establecido
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Realizar la petición de logout
        const response = await axios.post('/logout', {}, {
          withCredentials: true,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });
        console.log(response);
        // Limpiar cookies locales
        document.cookie.split(";").forEach(function(c) { 
          document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });

        // Redirigir al login
        this.$router.push('/login');
      } catch (error) {
        console.error('Error al cerrar sesión:', error.response?.data || error);
      }
    },
async updateUserPhoto() {
      try {
        if (!this.studentId) {
          console.error('No se pudo obtener el ID del estudiante');
          return;
        }

        // Usar tu método existente para obtener la foto
        const response = await getStudentPhoto(this.studentId);
        
        if (response.data && response.data.length > 0) {
          const studentData = response.data[0];
          
          // Enviar los datos actualizados al backend
          await this.updateProfileInBackend({
            name: studentData.Name,
            photo: studentData.Photo
          });
          
          // Actualizar datos locales
          this.user.name = studentData.Name;
          this.user.avatar = studentData.Photo;
          
          console.log('Foto actualizada exitosamente');
        }
      } catch (error) {
        console.error('Error actualizando foto:', error);
      }
    },

    async updateProfileInBackend(profileData) {
      try {
        // Obtener nuevo token CSRF si es necesario
        await axios.get('/sanctum/csrf-cookie');
        
        const response = await axios.post('/update-profile-data', profileData, {
          withCredentials: true,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });
        
        return response.data;
      } catch (error) {
        console.error('Error enviando datos al backend:', error);
        throw error;
      }
    },

    async checkAndUpdatePhotoIfNeeded() {
      try {
        const response = await axios.get('/check-photo-update-needed');
        
        if (response.data.needsUpdate) {
          await this.updateUserPhoto();
        }
      } catch (error) {
        console.error('Error verificando actualización de foto:', error);
      }
    },
  }
};
</script>